import client from './client';

const articlesApi = {
  list(params)     { return client.get('/articles', { params }).then(r => r.data); },
  featured()       { return client.get('/articles/featured').then(r => r.data.items); },
  getBySlug(slug)  { return client.get(`/articles/${slug}`).then(r => r.data); },
};

export default articlesApi;
